<template>
    <div class="flex min-h-full flex-1 flex-col justify-start px-6 py-12 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-sm">
            <h2 class="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">{{ $t('auth.login.title') }}</h2>
        </div>

        <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form class="space-y-6" action="#" method="POST" @submit.prevent="submitForm">
                <div v-if="errors?.email?.length || errors?.password?.length || errors?.general?.length" class="mb-4 text-sm text-red-600">
                    {{ errors.email?.[0] || errors.password?.[0] || errors.general?.[0] }}
                </div>
                <div>
                    <div class="mt-2">
                        <FloatLabel variant="in" class="w-full">
                            <InputText :invalid="!!errors.email" id="email" v-model="email" variant="filled" class="w-full" type="email" />
                            <label for="email">Email</label>
                        </FloatLabel>
                    </div>
                </div>

                <div>
                    <div class="flex items-center justify-between">
                        <FloatLabel variant="in" class="w-full">
                            <InputText id="password" v-model="password" variant="filled" class="w-full" type="password" />
                            <label for="password">Password</label>
                        </FloatLabel>
                    </div>
                </div>

                <div class="flex items-center justify-between">
                    <div class="text-sm">
                        <Button label="Link" variant="link">Forgot password?</Button>
                    </div>
                </div>


                <div>
                    <Button class="w-full" type="submit" variant="primary" :loading="loading">
                        Sign in
                    </Button>
                </div>
            </form>
        </div>

        <div class="mt-6 text-center text-sm text-gray-500">
            Don't have an account? <a href="/register" class="font-semibold text-emerald-600 hover:text-emerald-500">Sign
                up</a>
        </div>
    </div>
</template>

<script setup>
import InputText from 'primevue/inputtext';
import FloatLabel from 'primevue/floatlabel';
import Button from 'primevue/button';
import { ref } from 'vue';
import { useAuth } from '@/composables/useAuth';
import { useRouter } from 'vue-router';

const email = ref('');
const password = ref('');
const loading = ref(false);
const errors = ref({});
const route = useRouter();

const submitForm = () => {
    loading.value = true;

    useAuth()
        .login(email.value, password.value)
        .then(() => {
            // Handle successful login
            route.push({ name: 'home' });
        })
        .catch((error) => {
            if (error.response?.status === 422) {
                errors.value = error.response.data.errors;
                return;
            }
            errors.value = { general: [error.response?.data?.message] } ?? { general: ['An error occurred during login.'] };
        })
        .finally(() => {
            loading.value = false;
        });
};
</script>